export default __webpack_public_path__ + "static/delivery-box-68b7eaa6e19eb3e8eb2f2bc557522c7a.webp";